'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ControlsControlNoop = require('./Controls/ControlNoop');

var _ControlsControlNoop2 = _interopRequireDefault(_ControlsControlNoop);

var _ControlsControlString = require('./Controls/ControlString');

var _ControlsControlString2 = _interopRequireDefault(_ControlsControlString);

var _ControlsControlNumber = require('./Controls/ControlNumber');

var _ControlsControlNumber2 = _interopRequireDefault(_ControlsControlNumber);

var _ControlsControlText = require('./Controls/ControlText');

var _ControlsControlText2 = _interopRequireDefault(_ControlsControlText);

var _ControlsControlJson = require('./Controls/ControlJson');

var _ControlsControlJson2 = _interopRequireDefault(_ControlsControlJson);

var _ControlsControlBool = require('./Controls/ControlBool');

var _ControlsControlBool2 = _interopRequireDefault(_ControlsControlBool);

var _ControlsControlChoices = require('./Controls/ControlChoices');

var _ControlsControlChoices2 = _interopRequireDefault(_ControlsControlChoices);

var _stringify = require('./stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports['default'] = {

  constant: function constant(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlNoop2['default'],
      initialValue: initialValue
    };
  },

  string: function string(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlString2['default'],
      initialValue: initialValue
    };
  },

  number: function number(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlNumber2['default'],
      initialValue: initialValue
    };
  },

  text: function text(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlText2['default'],
      initialValue: initialValue
    };
  },

  json: function json(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlJson2['default'],
      initialValue: initialValue
    };
  },

  shape: function shape(props) {
    return {
      type: 'shape',
      props: props
    };
  },

  bool: function bool(initialValue) {
    return {
      type: 'value',
      Control: _ControlsControlBool2['default'],
      initialValue: initialValue
    };
  },

  choices: function choices(options, _initialValue) {

    var normOptions = Array.isArray(options) ? options.map(function (x) {
      return { label: _stringify2['default'](x), value: x };
    }) : Object.keys(options).map(function (key) {
      return { label: key, value: options[key] };
    });

    var initialValue = _initialValue === undefined ? normOptions[0].value : normOptions.filter(function (x) {
      return x.label === _initialValue || x.value === _initialValue;
    })[0].value;

    return {
      type: 'value',
      Control: _ControlsControlChoices2['default'],
      initialValue: initialValue,
      controlProps: {
        options: normOptions
      }
    };
  },

  callback: {

    log: function log() {
      var map = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      return {
        type: 'callback',
        callbackType: 'log',
        map: map
      };
    },

    logLatest: function logLatest() {
      var map = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      return {
        type: 'callback',
        callbackType: 'logLatest',
        map: map
      };
    }

  }

};
module.exports = exports['default'];